import { useQuery } from "@tanstack/react-query";
import { BrandSearchResult, BrandsService } from "@/services/brands.service";
import { adsHttpClient } from "@/utils/ads.http";

const brandsService = new BrandsService(adsHttpClient);

export type Brand = BrandSearchResult;

type UseBrandOptions = {
  enabled?: boolean;
};

async function fetchBrand(brandId: string): Promise<Brand | null> {
  return brandsService.searchById(brandId);
}

export function useBrand(
  brandId: string | undefined,
  options: UseBrandOptions = {},
) {
  const normalizedBrandId = brandId?.trim() ?? "";

  return useQuery({
    queryKey: ["brands", normalizedBrandId],
    queryFn: () => fetchBrand(normalizedBrandId),
    enabled: (options.enabled ?? true) && normalizedBrandId.length > 0,
  });
}
